// Relative imports
import { axiosInstance } from "./common";

export const getColors = async () => {
  const endpoint = "misc/colors/";
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
